/* eslint-disable class-methods-use-this */
import React from "react";
import { RiStackLine } from "react-icons/ri";
import { DashboardGroupBy } from "../../../__generated__/api";
import TicketItem from "../ticket-item";
import { GROUP_REGISTRY, GroupBy, GroupDescriptor } from "./base";

export default class QueueGroupBy extends GroupBy {
    public static shouldCreate(groupBy: DashboardGroupBy): boolean {
        return groupBy === DashboardGroupBy.Queue;
    }

    public getGroup(id: string, chats: TicketItem[]): GroupDescriptor {
        const firstQueue = chats.firstElement.ticket?.queue;

        return {
            id,
            icon: (
                <div className="group-letter-icon">
                    <RiStackLine />
                </div>
            ),
            title: firstQueue?.name ?? "No Queue" as string,
            subtitle: firstQueue?.description as string,
        };
    }

    public getGroupId(ticket: TicketItem): string | undefined {
        return ticket.ticket?.queueId;
    }
}

GROUP_REGISTRY.register(QueueGroupBy);
